export const LOCAL_STORAGE_KEY = "Asos.SavedLists.NotificationsOptInDismissed";
export const DISMISS_DURATION_MS = 30 * 24 * 60 * 60 * 1000;
